module.exports = __webpack_public_path__ + "img/PADRE.a6216e46.jpg";